module.exports = __webpack_public_path__ + "static/media/arrow-to-bottom.bd77e2df.svg";